import { GetSlackChannels } from '../../../domain/usecases';

import { BaseHttpService } from 'main/factories/http';

export class RemoteGetSlackChannels extends BaseHttpService<GetSlackChannels.Model> implements GetSlackChannels {
  async getSlackChannels(): Promise<GetSlackChannels.Model> {
    return await this.request('get');
  }
}
